<div class="attachments">
  <div class="attachments_summary">
    <span>{{ displayedFiles()?.length + ' Attachments' }}</span>
    <button (click)="triggerFileInput(fileInput)">
      <img src="assets/images/attach-square.svg" />
      Add Attachment
    </button>
  </div>
  <div *ngIf="fileSizeExceeded" class="attachments_error">
    File size exceeds the {{ maxFileSize() }}MB limit. Please upload a smaller
    file.
  </div>
  <div *ngIf="fileLimitExceeded" class="attachments_error">
    You can upload a maximum of {{ maxFiles() }} files per time.
  </div>

  @if (displayedFiles()?.length == 0) {
  <div class="attachments_empty">There's no attachments yet</div>
  }
  <div class="attachments_files">
    <div class="row row-gap-1">
      @for(fileObj of displayedFiles(); track fileObj; let index = $index) {
      <div class="attachments_files_item py-3 px-4 border-bottom">
        <div>
          <span
            title="dowload"
            (click)="onDownloadFile(index, fileObj.id, fileObj)"
          >
            {{ fileObj.attachmentDisplayName }}
          </span>
          <div class="d-flex">
            <button
              class="btn"
              (click)="onDeleteFile(index, fileObj.id)"
              title="delete"
            >
              <img src="assets/images/trash.svg" />
            </button>
          </div>
        </div>
        
          <span class="attachments_files_item_time">
            {{ 'Uploaded at ' + (fileObj.createdAt | date : 'MMMM dd,yyyy') }}
          </span>
          <span class="attachments_files_item_time">{{
            ', Uploaded by ' + fileObj.authorName
          }}</span>
        
      </div>
      }
    </div>
  </div>
  <input
    type="file"
    #fileInput
    (change)="onFileSelected($event)"
    style="display: none"
    [accept]="accept().join(',')"
    multiple
  />
</div>
